function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var p = Object.defineProperty,
    f = Object.defineProperties;
var i = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty,
    l = Object.prototype.propertyIsEnumerable;

var a = function a(e, o, m) {
  return o in e ? p(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: m
  }) : e[o] = m;
},
    s = function s(e, o) {
  for (var m in o || (o = {})) {
    c.call(o, m) && a(e, m, o[m]);
  }

  if (r) {
    var _iterator = _createForOfIteratorHelper(r(o)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var m = _step.value;
        l.call(o, m) && a(e, m, o[m]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    t = function t(e, o) {
  return f(e, i(o));
};

import n, { forwardRef as d } from "react";
import w from "../lib/IconBase.mjs";
import C from "../defs/CompassTool.mjs";
var I = d(function (e, o) {
  return /* @__PURE__ */n.createElement(w, t(s({
    ref: o
  }, e), {
    weights: C
  }));
});
I.displayName = "CompassTool";
export { I as CompassTool };